import React, { useEffect, useState, useRef, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiMoreHorizontal } from 'react-icons/fi';
import { FiArrowLeft } from "react-icons/fi";
import Loader from '../../loader/Loader';
import PostNewJobPopup from './PostNewJobPopup';
import { closeJobPost, deleteJobPost, editJobPost, viewJobPost } from '../../../services/operations/JobPostAPI';
import CreditContent from '../common/creditSection';
import ConfirmationPopup from './ConfirmationPopup';

const JobPostDetail = () => {

  const [result, setResult] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [clonePopup, setClonePopup] = useState(false);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const location = useLocation();
  const navigate = useNavigate()
  const loading = useSelector((state) => state.auth.loading)
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');
  const filter = searchParams.get('filter');
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);


  const viewPost = async () => {
    setLoaded(true);
    const result = await dispatch(viewJobPost(token, id));
    if (result?.data) {
      setResult(result.data.job)
    }
    setTimeout(() => {
      setLoaded(false);
    }, 5000);
  };

  useEffect(() => {
    viewPost();
  }, []);

  const handleClose = async () => {
    setConfirmPopup(true);
    // const payload = {
    //   job_status: "CLOSED"
    // }
    // await dispatch(closeJobPost(payload, token, id))
  }

  // const handleDelete = async () => {
  //  await dispatch(deleteJobPost(token, id))
  //   navigate('/dashboard/job-posting', { replace: true });
  // }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  const handlePublish = async (jobId) => {
    const payload = {
      company_name: result?.company_name,
      job_title: result?.job_title,
      job_location: result?.job_location,
      workplace_type: result?.workplace_type,
      employment_type: result?.employment_type,
      industries: result.industries ? JSON.parse(result.industries) : [],
      description: result?.description,
      salary_range: result?.salary_range,
      experience: result?.experience,
      skills: result.skills ? JSON.parse(result.skills) : [],
      job_status: "ACTIVE",
    };

    await dispatch(editJobPost(payload, token, () => { }, jobId));
    navigate('/dashboard/job-posting', { replace: true });

  }

  const handleCandidateClick = (job) => {
    const minimalData = {
      jobId: job.id,
      jobTitle: job.job_title,
      skills: job?.skills,
      niceToHaveSkills: job?.nice_to_have_skills,
      company: job?.company_name,
      industry: job?.industries,
      location: job?.job_location,
      experience: job?.experience,
      type: "Passive"
    }
    const encodedData = btoa(encodeURIComponent(JSON.stringify(minimalData)));
    const detailsURL = `/dashboard/relevant-candidates?data=${encodedData}`;
    window.open(detailsURL, '_blank');
  };

  const skills = result.skills ? JSON.parse(result.skills) : [];
  const industries = result.industries ? JSON.parse(result.industries) : [];

  return (
    <>
      <CreditContent />
      {loading && <Loader />}
      <div className='jobpost-dashboard'>
        <div className='jobpost-detail-first-section' style={{ position: "relative" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <button className="jobpost-back-button" onClick={() => navigate(`/dashboard/job-posting?filter=${filter}`)}>
              <FiArrowLeft style={{ marginRight: "5px" }} /> Back to {filter === "active" ? "Active Jobs" : filter === "closed" ? "Closed" : "Draft"}
            </button>
            {loaded ? (
              <button className="applicant-btn" style={{ minWidth: "160px", marginRight: "35px", display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                <span className="spinner-passive"></span>
                <span>Loading...</span>
              </button>
            ) : (
              <button
                onClick={() => handleCandidateClick(result)}
                className="applicant-btn"
                disabled={loaded || result?.passivecandidate === 0}
                style={{ minWidth: "160px", marginRight: "35px" }}
              >
                {result?.passivecandidate}
                <span style={{ fontWeight: "700" }}>
                  {result?.passivecandidate <= 1 ? " Passive candidate" : " Passive candidates"}
                </span>
              </button>
            )}


          </div>

          <p style={{ fontSize: "24px", fontWeight: "600" }}>{result?.job_title}</p>
          <p className='jobdetail-company-name'>{result?.company_name}</p>
          <p style={{ color: "rgba(0,0,0,0.5)", fontSize: "18px" }}>{result?.job_location}</p>

          <div className='jobpost-detail-first'>
            <p className='jobpost-detail-work-type'>{result?.workplace_type}</p>
            <p className='jobpost-detail-work-type'>{result?.employment_type}</p>
          </div>
          <div ref={dropdownRef} style={{ position: 'absolute', top: '25px', right: '20px' }}>
            <FiMoreHorizontal
              style={{ cursor: 'pointer', fontSize: '20px' }}
              onClick={() => setShowDropdown((prev) => !prev)}
            />
            {showDropdown && (
              <div
                className='jobpost-detail-dropdown-menu'
                style={{
                  position: 'absolute',
                  top: '24px',
                  right: '0px',
                  background: '#fff',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  borderRadius: "8px 0px 8px 8px"
                }}
              >
                {filter === "active" ? (
                  <>
                    <p className="jobpost-detail-dropdown-item" onClick={() => setShowEditPopup(true)}>Edit</p>
                    <p className="jobpost-detail-dropdown-item" onClick={handleClose}>Close this Job</p>
                    {/* <p className="jobpost-detail-dropdown-item" onClick={() => handleDelete(id)}>Delete</p> */}
                  </>
                ) : filter === "closed" ? (
                  <>
                    <p className="jobpost-detail-dropdown-item" onClick={() => setClonePopup(true)}>Clone</p>
                  </>
                ) : filter === "draft" ? (
                  <>
                    <p className="jobpost-detail-dropdown-item" onClick={() => setShowEditPopup(true)}>Edit</p>
                    <p className="jobpost-detail-dropdown-item" onClick={() => handlePublish(id)}>Publish</p>
                    <p className="jobpost-detail-dropdown-item" onClick={handleClose}>Close this Job</p>
                    {/* <p className="jobpost-detail-dropdown-item" onClick={() => handleDelete(id)}>Delete</p> */}
                  </>
                ) : null}

              </div>
            )}
          </div>
        </div>
        <div className='jobpost-detail-second-section'>
          <p style={{ fontWeight: "600", fontSize: "22px" }}>About the job</p>
          <p
            style={{
              all: "unset",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              fontSize: "13px",
              fontWeight: "400",
              lineHeight: "1.5",
            }}
            dangerouslySetInnerHTML={{ __html: result.description }}
          ></p>
          <p style={{ fontWeight: "600", fontSize: "22px", marginTop: '20px' }}>Skills required</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {skills.length > 0 && (
              skills.map((skill, index) => (
                <span
                  key={index}
                  style={{
                    background: 'white',
                    padding: '5px 10px',
                    borderRadius: '20px',
                    fontSize: '16px',
                    border: "0.5px solid rgba(45, 118, 253, 1)",
                    color: "rgba(45, 118, 253, 1)"
                  }}
                >
                  {skill}
                </span>
              )))}
          </div>
          <p style={{ fontWeight: "600", fontSize: "22px", marginTop: '20px' }}>Industries</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {industries.length > 0 && (
              industries.map((industry, index) => (
                <span
                  key={index}
                  style={{
                    background: 'white',
                    padding: '5px 10px',
                    borderRadius: '20px',
                    fontSize: '16px',
                    border: "0.5px solid rgba(45, 118, 253, 1)",
                    color: "rgba(45, 118, 253, 1)"
                  }}
                >
                  {industry}
                </span>
              )))}
          </div>
          {result?.experience && (() => {
            let expDisplay = "";
            let parsed;

            try {
              if (typeof result.experience === "string") {
                parsed = JSON.parse(result.experience);
              } else {
                parsed = result.experience;
              }
            } catch (e) {
              parsed = result.experience;
            }

            if (Array.isArray(parsed)) {
              expDisplay = parsed.join(", ");
            } else {
              expDisplay = parsed;
            }

            return (
              <>
                <p style={{ fontWeight: "600", fontSize: "22px", marginTop: '20px' }}>
                  Experience Required
                </p>
                <p style={{ fontSize: "18px" }}>{expDisplay} Years</p>
              </>
            );
          })()}

          {result?.salary_range && (<>
            <p style={{ fontWeight: "600", fontSize: "22px", marginTop: '20px' }}>Expected Salary</p>
            <p style={{ fontSize: "18px" }}>{result?.salary_range}</p>
          </>)}
          {
            result?.contract_price_per_hrs && (<>
              <p style={{ fontWeight: "600", fontSize: "22px", marginTop: '20px' }}>Contract Pay</p>
              <p style={{ fontSize: "18px" }}>${result?.contract_price_per_hrs}/hr</p>
            </>)
          }
        </div>
        <div className='jobpost-detail-third-section'>
          <p style={{ fontWeight: "600", fontSize: "22px" }}>Applicants</p>
          <p
            style={{
              fontSize: "18px",
              cursor: result.applicant_count > 0 ? "pointer" : "default",
              color: result.applicant_count > 0 ? "blue" : "gray"
            }}
          // onClick={result.applicant_count > 0 ? () => window.open(`/dashboard/relevant-applicants?data=${result.id}`, '_blank') : undefined}
          >
            {result.applicant_count} {result.applicant_count <= 1 ? 'Applicant' : 'Applicants'}</p>
        </div>
        {showEditPopup && (
          <PostNewJobPopup
            onClose={() => {
              setShowEditPopup(false);
            }}
            initialData={result}
            viewPost={viewPost}
            isEdit={true}
            jobId={id}
            filter={filter}
          />
        )}
        {clonePopup && (
          <PostNewJobPopup
            onClose={() => {
              setClonePopup(false);
            }}
            initialData={result}
            viewPost={viewPost}
            isClone={true}
            jobId={id}
            filter={filter}
          />
        )}
        {confirmPopup &&
          (
            <ConfirmationPopup onClose={() => setConfirmPopup(false)} id={id} fetchJobs={() => { }} filter={filter} setFilter={() => { }} />
          )}
      </div>
    </>
  );
};

export default JobPostDetail;
